import { deleteBajaAppTotalPass } from "../../actions/totalPass";
import { Preview } from "../../../types/IAction";
import { DeleteBajaAppTotalPass } from "../../reducers/totalPass";

/**
 * Baja de app TotalPass — mapDispatchToProps
 * Pantalla: /total-pass/baja-app
 */
export interface BajaAppDispatcher {
  deleteBajaAppTotalPass: (
    idPersona: number | string,
    userId?: number | string
  ) => Promise<Preview<DeleteBajaAppTotalPass>>;
}

export const bajaAppDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => BajaAppDispatcher = dispatch => ({
  deleteBajaAppTotalPass: (
    idPersona: number | string,
    userId?: number | string
  ) => {
    return dispatch(deleteBajaAppTotalPass(idPersona, userId));
  }
});
